import { RotateCcw } from 'lucide-react'
import { cn } from '../../lib/utils'
import { formatSecretTimestamp } from './secret-dashboard-utils'
import type { SecretVersion } from './secret-dashboard-types'

interface SecretVersionsPanelProps {
  versions: SecretVersion[]
  isDark: boolean
  onRollback: (version: SecretVersion) => void
}

export function SecretVersionsPanel({ versions, isDark, onRollback }: SecretVersionsPanelProps) {
  return (
    <section>
      <div className="mb-2 text-sm font-medium">Versions</div>
      {versions.length === 0 ? (
        <p className="text-xs text-neutral-500">No versions loaded.</p>
      ) : (
        <div className="space-y-1">
          {versions.map((version) => (
            <button
              key={version.id}
              type="button"
              onClick={() => onRollback(version)}
              className={cn('flex w-full items-center justify-between rounded-md px-2 py-1.5 text-left text-xs', isDark ? 'hover:bg-surface-2' : 'hover:bg-neutral-100')}
            >
              <span>
                v{version.version} {version.changeReason ? `- ${version.changeReason}` : ''}
                <span className="ml-2 text-neutral-500">{formatSecretTimestamp(version.createdAt)}</span>
              </span>
              <RotateCcw className="h-3.5 w-3.5" />
            </button>
          ))}
        </div>
      )}
    </section>
  )
}
